module.exports = __webpack_public_path__ + "img/logovp.c65362c6.svg";